// This file is auto-generated by @hey-api/openapi-ts

import { bambiApi } from '../internal/api.ts';
import {
  type TripsListApiArg,
  type TripsListApiResponse,
  type TripsCreateApiArg,
  type TripsCreateApiResponse,
  type TripsDestroyApiArg,
  type TripsDestroyApiResponse,
  type TripsRetrieveApiArg,
  type TripsRetrieveApiResponse,
  type TripsPartialUpdateApiArg,
  type TripsPartialUpdateApiResponse,
  type TripsAcceptPartialUpdateApiArg,
  type TripsAcceptPartialUpdateApiResponse,
  type TripsAcceptCancellationRequestPartialUpdateApiArg,
  type TripsAcceptCancellationRequestPartialUpdateApiResponse,
  type TripsActivateWillCallPartialUpdateApiArg,
  type TripsActivateWillCallPartialUpdateApiResponse,
  type TripsAddTripLegPartialUpdateApiArg,
  type TripsAddTripLegPartialUpdateApiResponse,
  type TripsAssignPartialUpdateApiArg,
  type TripsAssignPartialUpdateApiResponse,
  type TripsCancelPartialUpdateApiArg,
  type TripsCancelPartialUpdateApiResponse,
  type TripsCancelCodesRetrieveApiArg,
  type TripsCancelCodesRetrieveApiResponse,
  type TripsCancelReasonsRetrieveApiArg,
  type TripsCancelReasonsRetrieveApiResponse,
  type TripsCancellationRequestPartialUpdateApiArg,
  type TripsCancellationRequestPartialUpdateApiResponse,
  type TripsCompletePartialUpdateApiArg,
  type TripsCompletePartialUpdateApiResponse,
  type TripsCorrelatedListApiArg,
  type TripsCorrelatedListApiResponse,
  type TripsCreatesListApiArg,
  type TripsCreatesListApiResponse,
  type TripsDriverEnteredNotesPartialUpdateApiArg,
  type TripsDriverEnteredNotesPartialUpdateApiResponse,
  type TripsEventManualCreatePartialUpdateApiArg,
  type TripsEventManualCreatePartialUpdateApiResponse,
  type TripsEventsListApiArg,
  type TripsEventsListApiResponse,
  type TripsLocationsListApiArg,
  type TripsLocationsListApiResponse,
  type TripsLockPartialUpdateApiArg,
  type TripsLockPartialUpdateApiResponse,
  type TripsOverrideStatusPartialUpdateApiArg,
  type TripsOverrideStatusPartialUpdateApiResponse,
  type TripsPriceSummaryRetrieveApiArg,
  type TripsPriceSummaryRetrieveApiResponse,
  type TripsReassignPartialUpdateApiArg,
  type TripsReassignPartialUpdateApiResponse,
  type TripsRejectPartialUpdateApiArg,
  type TripsRejectPartialUpdateApiResponse,
  type TripsRejectCancellationRequestPartialUpdateApiArg,
  type TripsRejectCancellationRequestPartialUpdateApiResponse,
  type TripsRejectCodesRetrieveApiArg,
  type TripsRejectCodesRetrieveApiResponse,
  type TripsRejectReasonsRetrieveApiArg,
  type TripsRejectReasonsRetrieveApiResponse,
  type TripsRelatedListApiArg,
  type TripsRelatedListApiResponse,
  type TripsRemoveCancellationRequestPartialUpdateApiArg,
  type TripsRemoveCancellationRequestPartialUpdateApiResponse,
  type TripsSignaturesListApiArg,
  type TripsSignaturesListApiResponse,
  type TripsSnappedRouteRetrieveApiArg,
  type TripsSnappedRouteRetrieveApiResponse,
  type TripsStatusPartialUpdateApiArg,
  type TripsStatusPartialUpdateApiResponse,
  type TripsSummaryRetrieveApiArg,
  type TripsSummaryRetrieveApiResponse,
  type TripsTurnbackReasonsRetrieveApiArg,
  type TripsTurnbackReasonsRetrieveApiResponse,
  type TripsUnassignPartialUpdateApiArg,
  type TripsUnassignPartialUpdateApiResponse,
  type TripsUncancelPartialUpdateApiArg,
  type TripsUncancelPartialUpdateApiResponse,
  type TripsUnlockPartialUpdateApiArg,
  type TripsUnlockPartialUpdateApiResponse,
  type TripsUnrejectPartialUpdateApiArg,
  type TripsUnrejectPartialUpdateApiResponse,
  type TripsUpdatePickupAtPartialUpdateApiArg,
  type TripsUpdatePickupAtPartialUpdateApiResponse,
  type TripsUpdatesListApiArg,
  type TripsUpdatesListApiResponse,
  type TripsValidatePartialUpdateApiArg,
  type TripsValidatePartialUpdateApiResponse,
  type TripsActivatedWillCallCountRetrieveApiArg,
  type TripsActivatedWillCallCountRetrieveApiResponse,
  type TripsAllListApiArg,
  type TripsAllListApiResponse,
  type TripsBulkAcceptCreateApiArg,
  type TripsBulkAcceptCreateApiResponse,
  type TripsBulkAssignCreateApiArg,
  type TripsBulkAssignCreateApiResponse,
  type TripsBulkCancelCreateApiArg,
  type TripsBulkCancelCreateApiResponse,
  type TripsBulkCancelReasonsCreateApiArg,
  type TripsBulkCancelReasonsCreateApiResponse,
  type TripsBulkPriceCreateApiArg,
  type TripsBulkPriceCreateApiResponse,
  type TripsBulkPriceConfirmCreateApiArg,
  type TripsBulkPriceConfirmCreateApiResponse,
  type TripsBulkReassignCreateApiArg,
  type TripsBulkReassignCreateApiResponse,
  type TripsBulkRejectCreateApiArg,
  type TripsBulkRejectCreateApiResponse,
  type TripsBulkRejectReasonsCreateApiArg,
  type TripsBulkRejectReasonsCreateApiResponse,
  type TripsBulkTripEventsCreateApiArg,
  type TripsBulkTripEventsCreateApiResponse,
  type TripsBulkUnassignCreateApiArg,
  type TripsBulkUnassignCreateApiResponse,
  type TripsBulkValidateCreateApiArg,
  type TripsBulkValidateCreateApiResponse,
  type TripsExportRetrieveApiArg,
  type TripsExportRetrieveApiResponse,
  type TripsMtmDriverManifestListApiArg,
  type TripsMtmDriverManifestListApiResponse,
  type TripsMultiloadListApiArg,
  type TripsMultiloadListApiResponse,
  type TripsMultiloadCreateApiArg,
  type TripsMultiloadCreateApiResponse,
  type TripsMultiloadDestroyApiArg,
  type TripsMultiloadDestroyApiResponse,
  type TripsMultiloadRetrieveApiArg,
  type TripsMultiloadRetrieveApiResponse,
  type TripsMultiloadPartialUpdateApiArg,
  type TripsMultiloadPartialUpdateApiResponse,
  type TripsMultiloadMobileRetrieveApiArg,
  type TripsMultiloadMobileRetrieveApiResponse,
  type TripsRequestedCountRetrieveApiArg,
  type TripsRequestedCountRetrieveApiResponse,
  type TripsSubscriptionsListApiArg,
  type TripsSubscriptionsListApiResponse,
  type TripsSubscriptionsCreateApiArg,
  type TripsSubscriptionsCreateApiResponse,
  type TripsSubscriptionsDestroyApiArg,
  type TripsSubscriptionsDestroyApiResponse,
  type TripsSubscriptionsRetrieveApiArg,
  type TripsSubscriptionsRetrieveApiResponse,
  type TripsSubscriptionsPartialUpdateApiArg,
  type TripsSubscriptionsPartialUpdateApiResponse,
  type TripsSuggestedPickupAtCreateApiArg,
  type TripsSuggestedPickupAtCreateApiResponse,
  type TripsTripSubscriptionExpiringSoonCountRetrieveApiArg,
  type TripsTripSubscriptionExpiringSoonCountRetrieveApiResponse,
  type TripsWithSummaryListApiArg,
  type TripsWithSummaryListApiResponse,
} from './operations.gen.ts';

export const addTagTypes = ['trips'] as const;

const injectedTripsRtkApi = bambiApi
  .enhanceEndpoints({ addTagTypes })
  .injectEndpoints({
    endpoints: (build) => ({
      tripsList: build.query<TripsListApiResponse, TripsListApiArg>({
        query: (queryArg) => ({
          url: `/trips/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            deleted_at_range_end: queryArg.deletedAtRangeEnd,
            deleted_at_range_start: queryArg.deletedAtRangeStart,
            deleted_objects: queryArg.deletedObjects,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            has_unpaid_invoice: queryArg.hasUnpaidInvoice,
            id__in: queryArg.idIn,
            import_file_id__in: queryArg.importFileIdIn,
            import_template_id__in: queryArg.importTemplateIdIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passenger_tag__in: queryArg.passengerTagIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCreate: build.mutation<TripsCreateApiResponse, TripsCreateApiArg>({
        query: (queryArg) => ({
          url: `/trips/`,
          method: 'POST',
          body: queryArg.tripsBulkCreateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsDestroy: build.mutation<TripsDestroyApiResponse, TripsDestroyApiArg>(
        {
          query: (queryArg) => ({
            url: `/trips/${queryArg.id}/`,
            method: 'DELETE',
            headers: {
              ...(queryArg.organizationId !== undefined && {
                'Organization-ID': queryArg.organizationId,
              }),
            },
          }),
          invalidatesTags: ['trips'],
        }
      ),
      tripsRetrieve: build.query<TripsRetrieveApiResponse, TripsRetrieveApiArg>(
        {
          query: (queryArg) => ({
            url: `/trips/${queryArg.id}/`,
            headers: {
              ...(queryArg.organizationId !== undefined && {
                'Organization-ID': queryArg.organizationId,
              }),
            },
          }),
          providesTags: ['trips'],
        }
      ),
      tripsPartialUpdate: build.mutation<
        TripsPartialUpdateApiResponse,
        TripsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTripWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsAcceptPartialUpdate: build.mutation<
        TripsAcceptPartialUpdateApiResponse,
        TripsAcceptPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/accept/`,
          method: 'PATCH',
          body: queryArg.patchedTripAccept,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsAcceptCancellationRequestPartialUpdate: build.mutation<
        TripsAcceptCancellationRequestPartialUpdateApiResponse,
        TripsAcceptCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/accept-cancellation-request/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsActivateWillCallPartialUpdate: build.mutation<
        TripsActivateWillCallPartialUpdateApiResponse,
        TripsActivateWillCallPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/activate-will-call/`,
          method: 'PATCH',
          body: queryArg.patchedTripActivateWillCall,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsAddTripLegPartialUpdate: build.mutation<
        TripsAddTripLegPartialUpdateApiResponse,
        TripsAddTripLegPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/add-trip-leg/`,
          method: 'PATCH',
          body: queryArg.patchedTripAddTripLegWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsAssignPartialUpdate: build.mutation<
        TripsAssignPartialUpdateApiResponse,
        TripsAssignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/assign/`,
          method: 'PATCH',
          body: queryArg.patchedTripAssign,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsCancelPartialUpdate: build.mutation<
        TripsCancelPartialUpdateApiResponse,
        TripsCancelPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel/`,
          method: 'PATCH',
          body: queryArg.patchedTripCancel,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsCancelCodesRetrieve: build.query<
        TripsCancelCodesRetrieveApiResponse,
        TripsCancelCodesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel-codes/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCancelReasonsRetrieve: build.query<
        TripsCancelReasonsRetrieveApiResponse,
        TripsCancelReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel-reasons/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCancellationRequestPartialUpdate: build.mutation<
        TripsCancellationRequestPartialUpdateApiResponse,
        TripsCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancellation-request/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsCompletePartialUpdate: build.mutation<
        TripsCompletePartialUpdateApiResponse,
        TripsCompletePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/complete/`,
          method: 'PATCH',
          body: queryArg.patchedTripComplete,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsCorrelatedList: build.query<
        TripsCorrelatedListApiResponse,
        TripsCorrelatedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/correlated/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsCreatesList: build.query<
        TripsCreatesListApiResponse,
        TripsCreatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/creates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsDriverEnteredNotesPartialUpdate: build.mutation<
        TripsDriverEnteredNotesPartialUpdateApiResponse,
        TripsDriverEnteredNotesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/driver-entered-notes/`,
          method: 'PATCH',
          body: queryArg.patchedTripUpdateDriverEnteredNotes,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsEventManualCreatePartialUpdate: build.mutation<
        TripsEventManualCreatePartialUpdateApiResponse,
        TripsEventManualCreatePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/event-manual-create/`,
          method: 'PATCH',
          body: queryArg.patchedTripManualUpdate,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsEventsList: build.query<
        TripsEventsListApiResponse,
        TripsEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/events/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsLocationsList: build.query<
        TripsLocationsListApiResponse,
        TripsLocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/locations/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page },
        }),
        providesTags: ['trips'],
      }),
      tripsLockPartialUpdate: build.mutation<
        TripsLockPartialUpdateApiResponse,
        TripsLockPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/lock/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsOverrideStatusPartialUpdate: build.mutation<
        TripsOverrideStatusPartialUpdateApiResponse,
        TripsOverrideStatusPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/override-status/`,
          method: 'PATCH',
          body: queryArg.patchedTripOverrideStatusChange,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsPriceSummaryRetrieve: build.query<
        TripsPriceSummaryRetrieveApiResponse,
        TripsPriceSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/trips/${queryArg.id}/price-summary/` }),
        providesTags: ['trips'],
      }),
      tripsReassignPartialUpdate: build.mutation<
        TripsReassignPartialUpdateApiResponse,
        TripsReassignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reassign/`,
          method: 'PATCH',
          body: queryArg.patchedTripReassign,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsRejectPartialUpdate: build.mutation<
        TripsRejectPartialUpdateApiResponse,
        TripsRejectPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject/`,
          method: 'PATCH',
          body: queryArg.patchedTripReject,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsRejectCancellationRequestPartialUpdate: build.mutation<
        TripsRejectCancellationRequestPartialUpdateApiResponse,
        TripsRejectCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-cancellation-request/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsRejectCodesRetrieve: build.query<
        TripsRejectCodesRetrieveApiResponse,
        TripsRejectCodesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-codes/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsRejectReasonsRetrieve: build.query<
        TripsRejectReasonsRetrieveApiResponse,
        TripsRejectReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-reasons/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsRelatedList: build.query<
        TripsRelatedListApiResponse,
        TripsRelatedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/related/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsRemoveCancellationRequestPartialUpdate: build.mutation<
        TripsRemoveCancellationRequestPartialUpdateApiResponse,
        TripsRemoveCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/remove-cancellation-request/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsSignaturesList: build.query<
        TripsSignaturesListApiResponse,
        TripsSignaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/signatures/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsSnappedRouteRetrieve: build.query<
        TripsSnappedRouteRetrieveApiResponse,
        TripsSnappedRouteRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/snapped-route/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsStatusPartialUpdate: build.mutation<
        TripsStatusPartialUpdateApiResponse,
        TripsStatusPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/status/`,
          method: 'PATCH',
          body: queryArg.patchedTripStatusChange,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsSummaryRetrieve: build.query<
        TripsSummaryRetrieveApiResponse,
        TripsSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/trips/${queryArg.id}/summary/` }),
        providesTags: ['trips'],
      }),
      tripsTurnbackReasonsRetrieve: build.query<
        TripsTurnbackReasonsRetrieveApiResponse,
        TripsTurnbackReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/turnback-reasons/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsUnassignPartialUpdate: build.mutation<
        TripsUnassignPartialUpdateApiResponse,
        TripsUnassignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unassign/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsUncancelPartialUpdate: build.mutation<
        TripsUncancelPartialUpdateApiResponse,
        TripsUncancelPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/uncancel/`,
          method: 'PATCH',
          body: queryArg.patchedTripUncancel,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsUnlockPartialUpdate: build.mutation<
        TripsUnlockPartialUpdateApiResponse,
        TripsUnlockPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unlock/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsUnrejectPartialUpdate: build.mutation<
        TripsUnrejectPartialUpdateApiResponse,
        TripsUnrejectPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unreject/`,
          method: 'PATCH',
          body: queryArg.patchedTripUnreject,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsUpdatePickupAtPartialUpdate: build.mutation<
        TripsUpdatePickupAtPartialUpdateApiResponse,
        TripsUpdatePickupAtPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/update-pickup-at/`,
          method: 'PATCH',
          body: queryArg.patchedTripUpdatePickupAt,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsUpdatesList: build.query<
        TripsUpdatesListApiResponse,
        TripsUpdatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/updates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsValidatePartialUpdate: build.mutation<
        TripsValidatePartialUpdateApiResponse,
        TripsValidatePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/validate/`,
          method: 'PATCH',
          body: queryArg.patchedTripValidate,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsActivatedWillCallCountRetrieve: build.query<
        TripsActivatedWillCallCountRetrieveApiResponse,
        TripsActivatedWillCallCountRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/activated-will-call-count/`,
          params: {
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsAllList: build.query<TripsAllListApiResponse, TripsAllListApiArg>({
        query: (queryArg) => ({
          url: `/trips/all/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            has_unpaid_invoice: queryArg.hasUnpaidInvoice,
            id__in: queryArg.idIn,
            import_file_id__in: queryArg.importFileIdIn,
            import_template_id__in: queryArg.importTemplateIdIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            passenger__in: queryArg.passengerIn,
            passenger_tag__in: queryArg.passengerTagIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsBulkAcceptCreate: build.mutation<
        TripsBulkAcceptCreateApiResponse,
        TripsBulkAcceptCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-accept/`,
          method: 'POST',
          body: queryArg.bulkTripAcceptWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkAssignCreate: build.mutation<
        TripsBulkAssignCreateApiResponse,
        TripsBulkAssignCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-assign/`,
          method: 'POST',
          body: queryArg.bulkTripAssign,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkCancelCreate: build.mutation<
        TripsBulkCancelCreateApiResponse,
        TripsBulkCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-cancel/`,
          method: 'POST',
          body: queryArg.bulkTripCancelWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkCancelReasonsCreate: build.query<
        TripsBulkCancelReasonsCreateApiResponse,
        TripsBulkCancelReasonsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-cancel-reasons/`,
          method: 'POST',
          body: queryArg.bulkTripCancelReasonsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsBulkPriceCreate: build.mutation<
        TripsBulkPriceCreateApiResponse,
        TripsBulkPriceCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-price/`,
          method: 'POST',
          body: queryArg.bulkTripPriceChangeWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkPriceConfirmCreate: build.mutation<
        TripsBulkPriceConfirmCreateApiResponse,
        TripsBulkPriceConfirmCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-price/confirm/`,
          method: 'POST',
          body: queryArg.bulkTripPriceChangeConfirm,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkReassignCreate: build.mutation<
        TripsBulkReassignCreateApiResponse,
        TripsBulkReassignCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-reassign/`,
          method: 'POST',
          body: queryArg.bulkTripReassign,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkRejectCreate: build.mutation<
        TripsBulkRejectCreateApiResponse,
        TripsBulkRejectCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-reject/`,
          method: 'POST',
          body: queryArg.bulkTripRejectWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkRejectReasonsCreate: build.query<
        TripsBulkRejectReasonsCreateApiResponse,
        TripsBulkRejectReasonsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-reject-reasons/`,
          method: 'POST',
          body: queryArg.bulkTripRejectReasonsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsBulkTripEventsCreate: build.mutation<
        TripsBulkTripEventsCreateApiResponse,
        TripsBulkTripEventsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-trip-events/`,
          method: 'POST',
          body: queryArg.bulkTripIdRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkUnassignCreate: build.mutation<
        TripsBulkUnassignCreateApiResponse,
        TripsBulkUnassignCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-unassign/`,
          method: 'POST',
          body: queryArg.bulkTripUnassign,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsBulkValidateCreate: build.mutation<
        TripsBulkValidateCreateApiResponse,
        TripsBulkValidateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-validate/`,
          method: 'POST',
          body: queryArg.bulkTripValidateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsExportRetrieve: build.query<
        TripsExportRetrieveApiResponse,
        TripsExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/export/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            has_unpaid_invoice: queryArg.hasUnpaidInvoice,
            id__in: queryArg.idIn,
            import_file_id__in: queryArg.importFileIdIn,
            import_template_id__in: queryArg.importTemplateIdIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            output_set: queryArg.outputSet,
            passenger__in: queryArg.passengerIn,
            passenger_tag__in: queryArg.passengerTagIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsMtmDriverManifestList: build.query<
        TripsMtmDriverManifestListApiResponse,
        TripsMtmDriverManifestListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/mtm-driver-manifest/`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadList: build.query<
        TripsMultiloadListApiResponse,
        TripsMultiloadListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadCreate: build.mutation<
        TripsMultiloadCreateApiResponse,
        TripsMultiloadCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/`,
          method: 'POST',
          body: queryArg.multiloadWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsMultiloadDestroy: build.mutation<
        TripsMultiloadDestroyApiResponse,
        TripsMultiloadDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsMultiloadRetrieve: build.query<
        TripsMultiloadRetrieveApiResponse,
        TripsMultiloadRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadPartialUpdate: build.mutation<
        TripsMultiloadPartialUpdateApiResponse,
        TripsMultiloadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMultiloadWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsMultiloadMobileRetrieve: build.query<
        TripsMultiloadMobileRetrieveApiResponse,
        TripsMultiloadMobileRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/mobile/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsRequestedCountRetrieve: build.query<
        TripsRequestedCountRetrieveApiResponse,
        TripsRequestedCountRetrieveApiArg
      >({
        query: () => ({ url: `/trips/requested-count/` }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsList: build.query<
        TripsSubscriptionsListApiResponse,
        TripsSubscriptionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payers: queryArg.payers,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsCreate: build.mutation<
        TripsSubscriptionsCreateApiResponse,
        TripsSubscriptionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/`,
          method: 'POST',
          body: queryArg.tripSubscriptionWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsSubscriptionsDestroy: build.mutation<
        TripsSubscriptionsDestroyApiResponse,
        TripsSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { delete: queryArg.delete },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsSubscriptionsRetrieve: build.query<
        TripsSubscriptionsRetrieveApiResponse,
        TripsSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsPartialUpdate: build.mutation<
        TripsSubscriptionsPartialUpdateApiResponse,
        TripsSubscriptionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTripSubscriptionWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsSuggestedPickupAtCreate: build.mutation<
        TripsSuggestedPickupAtCreateApiResponse,
        TripsSuggestedPickupAtCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/suggested-pickup-at/`,
          method: 'POST',
          body: queryArg.tripSuggestedPickupTime,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      tripsTripSubscriptionExpiringSoonCountRetrieve: build.query<
        TripsTripSubscriptionExpiringSoonCountRetrieveApiResponse,
        TripsTripSubscriptionExpiringSoonCountRetrieveApiArg
      >({
        query: () => ({ url: `/trips/trip-subscription-expiring-soon-count/` }),
        providesTags: ['trips'],
      }),
      tripsWithSummaryList: build.query<
        TripsWithSummaryListApiResponse,
        TripsWithSummaryListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/with-summary/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            has_unpaid_invoice: queryArg.hasUnpaidInvoice,
            id__in: queryArg.idIn,
            import_file_id__in: queryArg.importFileIdIn,
            import_template_id__in: queryArg.importTemplateIdIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passenger_tag__in: queryArg.passengerTagIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useTripsListQuery,
  useLazyTripsListQuery,
  useTripsCreateMutation,
  useTripsDestroyMutation,
  useTripsRetrieveQuery,
  useLazyTripsRetrieveQuery,
  useTripsPartialUpdateMutation,
  useTripsAcceptPartialUpdateMutation,
  useTripsAcceptCancellationRequestPartialUpdateMutation,
  useTripsActivateWillCallPartialUpdateMutation,
  useTripsAddTripLegPartialUpdateMutation,
  useTripsAssignPartialUpdateMutation,
  useTripsCancelPartialUpdateMutation,
  useTripsCancelCodesRetrieveQuery,
  useLazyTripsCancelCodesRetrieveQuery,
  useTripsCancelReasonsRetrieveQuery,
  useLazyTripsCancelReasonsRetrieveQuery,
  useTripsCancellationRequestPartialUpdateMutation,
  useTripsCompletePartialUpdateMutation,
  useTripsCorrelatedListQuery,
  useLazyTripsCorrelatedListQuery,
  useTripsCreatesListQuery,
  useLazyTripsCreatesListQuery,
  useTripsDriverEnteredNotesPartialUpdateMutation,
  useTripsEventManualCreatePartialUpdateMutation,
  useTripsEventsListQuery,
  useLazyTripsEventsListQuery,
  useTripsLocationsListQuery,
  useLazyTripsLocationsListQuery,
  useTripsLockPartialUpdateMutation,
  useTripsOverrideStatusPartialUpdateMutation,
  useTripsPriceSummaryRetrieveQuery,
  useLazyTripsPriceSummaryRetrieveQuery,
  useTripsReassignPartialUpdateMutation,
  useTripsRejectPartialUpdateMutation,
  useTripsRejectCancellationRequestPartialUpdateMutation,
  useTripsRejectCodesRetrieveQuery,
  useLazyTripsRejectCodesRetrieveQuery,
  useTripsRejectReasonsRetrieveQuery,
  useLazyTripsRejectReasonsRetrieveQuery,
  useTripsRelatedListQuery,
  useLazyTripsRelatedListQuery,
  useTripsRemoveCancellationRequestPartialUpdateMutation,
  useTripsSignaturesListQuery,
  useLazyTripsSignaturesListQuery,
  useTripsSnappedRouteRetrieveQuery,
  useLazyTripsSnappedRouteRetrieveQuery,
  useTripsStatusPartialUpdateMutation,
  useTripsSummaryRetrieveQuery,
  useLazyTripsSummaryRetrieveQuery,
  useTripsTurnbackReasonsRetrieveQuery,
  useLazyTripsTurnbackReasonsRetrieveQuery,
  useTripsUnassignPartialUpdateMutation,
  useTripsUncancelPartialUpdateMutation,
  useTripsUnlockPartialUpdateMutation,
  useTripsUnrejectPartialUpdateMutation,
  useTripsUpdatePickupAtPartialUpdateMutation,
  useTripsUpdatesListQuery,
  useLazyTripsUpdatesListQuery,
  useTripsValidatePartialUpdateMutation,
  useTripsActivatedWillCallCountRetrieveQuery,
  useLazyTripsActivatedWillCallCountRetrieveQuery,
  useTripsAllListQuery,
  useLazyTripsAllListQuery,
  useTripsBulkAcceptCreateMutation,
  useTripsBulkAssignCreateMutation,
  useTripsBulkCancelCreateMutation,
  useTripsBulkCancelReasonsCreateQuery,
  useLazyTripsBulkCancelReasonsCreateQuery,
  useTripsBulkPriceCreateMutation,
  useTripsBulkPriceConfirmCreateMutation,
  useTripsBulkReassignCreateMutation,
  useTripsBulkRejectCreateMutation,
  useTripsBulkRejectReasonsCreateQuery,
  useLazyTripsBulkRejectReasonsCreateQuery,
  useTripsBulkTripEventsCreateMutation,
  useTripsBulkUnassignCreateMutation,
  useTripsBulkValidateCreateMutation,
  useTripsExportRetrieveQuery,
  useLazyTripsExportRetrieveQuery,
  useTripsMtmDriverManifestListQuery,
  useLazyTripsMtmDriverManifestListQuery,
  useTripsMultiloadListQuery,
  useLazyTripsMultiloadListQuery,
  useTripsMultiloadCreateMutation,
  useTripsMultiloadDestroyMutation,
  useTripsMultiloadRetrieveQuery,
  useLazyTripsMultiloadRetrieveQuery,
  useTripsMultiloadPartialUpdateMutation,
  useTripsMultiloadMobileRetrieveQuery,
  useLazyTripsMultiloadMobileRetrieveQuery,
  useTripsRequestedCountRetrieveQuery,
  useLazyTripsRequestedCountRetrieveQuery,
  useTripsSubscriptionsListQuery,
  useLazyTripsSubscriptionsListQuery,
  useTripsSubscriptionsCreateMutation,
  useTripsSubscriptionsDestroyMutation,
  useTripsSubscriptionsRetrieveQuery,
  useLazyTripsSubscriptionsRetrieveQuery,
  useTripsSubscriptionsPartialUpdateMutation,
  useTripsSuggestedPickupAtCreateMutation,
  useTripsTripSubscriptionExpiringSoonCountRetrieveQuery,
  useLazyTripsTripSubscriptionExpiringSoonCountRetrieveQuery,
  useTripsWithSummaryListQuery,
  useLazyTripsWithSummaryListQuery,
} = injectedTripsRtkApi;
